import {get} from "lodash";
import {breakpoints, colors} from "./constants";
const parseThemePath = (themePath, theme, defaultValue) => {
  if (Array.isArray(themePath))
    return themePath;
  if (themePath === "transparent")
    return "transparent";
  if (themePath === "inherit")
    return "inherit";
  if (themePath === "currentColor")
    return "currentColor";
  if (themePath === "light" || themePath === "normal" || themePath === "bold" || themePath === "heavy" || themePath === "300" || themePath === "400" || themePath === "500" || themePath === "600" || themePath === "700" || themePath === "900") {
    return themePath;
  }
  if (themePath && typeof themePath === "string" && themePath.includes("#") || themePath && typeof themePath === "string" && themePath.includes("%") || themePath && typeof themePath === "string" && themePath.includes("px") || themePath && typeof themePath === "string" && themePath.includes("rgba") || themePath && typeof themePath === "string" && themePath.includes("gradient")) {
    return themePath;
  }
  return get(theme, themePath, defaultValue);
};
const getTShirtSizes = (size) => size.replace(/xs/g, "4px").replace(/sm/g, "8px").replace(/md/g, "16px").replace(/lg/g, "24px").replace(/xl/g, "48px");
const getFontSizes = (size) => size.replace(/xs/g, "12px").replace(/sm/g, "14px").replace(/md/g, "16px").replace(/lg/g, "20px").replace(/xl/g, "30px");
const getResponsiveRules = (property, value) => {
  if (!value) {
    return "";
  }
  if (typeof value === "string") {
    return `${property}: ${property === "font-size" ? getFontSizes(value) : getTShirtSizes(value)};`;
  } else if (Array.isArray(value)) {
    const [base, ...values] = value;
    const rule = `${property}: ${getTShirtSizes(base)};
`;
    return values.reduce((rule2, val, i) => {
      let value2;
      switch (property) {
        case "display":
          value2 = val;
          break;
        case "font-size":
          value2 = getFontSizes(val);
          break;
        default:
          value2 = getTShirtSizes(val);
      }
      return rule2 + `@media(min-width: ${breakpoints[i]}) { ${property}: ${value2}};`;
    }, rule);
  }
  return "";
};
export {
  colors,
  getResponsiveRules,
  getTShirtSizes,
  parseThemePath
};
